import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function RelationshipsGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'love-&-relationships' });
  const activities = useNamedSelector('clarity.activities', { category: 'love-&-relationships' });
  return (
    <List tiny-gutter>
      <p>Look at your answers from the previous page and set yourself a specific and measureable relationship goal. It should be something that will have a big positive impact on your relationship and love life.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>What are one or two actions you can take today or this week that will set you on the path to achieving your goal? Commit to taking that action.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
